import React, { useState } from 'react';
import { callDemo, demoErrorMessage } from './demoApi';

// Touchpoint 2: "Paste 2-3 of your Google reviews → watch AI write your homepage intro"
const ReviewIntroDemo = () => {
  const [reviews, setReviews] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const canSubmit = reviews.trim().length >= 15 && !loading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const data = await callDemo('review_intro', { reviews: reviews.trim() });
      setResult(data);
    } catch (err) {
      setError(demoErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card demo-card">
      <div className="ic">✍️</div>
      <h4>Watch AI write your homepage intro</h4>
      <p className="demo-sub">Paste 2–3 of your real Google (or Yelp/Facebook) reviews.</p>
      <textarea
        className="demo-textarea"
        rows={4}
        placeholder="Paste a couple of real customer reviews here…"
        value={reviews}
        onChange={(e) => setReviews(e.target.value)}
        maxLength={2000}
      />
      <button className="demo-btn" onClick={handleSubmit} disabled={!canSubmit}>
        {loading ? 'Writing…' : 'Show me →'}
      </button>
      {error && <p className="demo-error">{error}</p>}
      {result && (
        <div className="demo-result">
          <h5>Your homepage intro (~60 words)</h5>
          <p>{result.intro}</p>
          {result.headlines?.length > 0 && (
            <>
              <h5 style={{ marginTop: 10 }}>Headline options</h5>
              <ul>
                {result.headlines.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
      {result && (
        <a href="/order" className="demo-cta">
          Want this on your own site? $199, live in 48 hours →
        </a>
      )}
      <p className="demo-privacy">🔒 Nothing you type here is saved.</p>
    </div>
  );
};

export default ReviewIntroDemo;
